// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.up-page {
  min-height: 100vh;
  background: #f4f4f6;
  padding: 24px 16px 48px;
  box-sizing: border-box;
}
.up-card {
  max-width: 640px;
  margin: 0 auto;
  background: #fff;
  border-radius: 20px;
  padding: 28px 22px 24px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}
.up-title {
  margin: 0 0 10px;
  font-size: clamp(1.6rem, 6vw, 2.1rem);
  line-height: 1.15;
  color: #111;
}
.up-description {
  margin: 0 0 22px;
  color: #666;
  font-size: 1rem;
  line-height: 1.55;
}
.up-warning {
  background: #fff3cd;
  border: 1px solid #ffe69c;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 16px;
  color: #856404;
  font-size: 0.92rem;
}
.up-options {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 20px;
}
.up-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 60px;
  padding: 14px 18px;
  background: #fff;
  border: 2px solid #e6e6ea;
  border-radius: 14px;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
}
.up-option.is-active {
  border-color: #e6288f;
  background: #fff5fa;
  box-shadow: 0 4px 14px rgba(230, 40, 143, 0.15);
}
.up-option-label {
  font-weight: 700;
  font-size: 1rem;
  color: #111;
  text-align: left;
}
.up-option-price {
  font-weight: 800;
  font-size: 1.15rem;
  color: #111;
  white-space: nowrap;
}
.up-option.is-active .up-option-price {
  color: #e6288f;
}
.up-select-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 54px;
  background: #111;
  color: #fff;
  border-radius: 14px;
  font-weight: 700;
  font-size: 1.05rem;
  cursor: pointer;
  transition: transform 0.1s, background 0.15s;
}
.up-select-btn:active {
  transform: scale(0.98);
}
.up-count {
  margin: 12px 0 0;
  text-align: center;
  color: #666;
  font-size: 0.95rem;
}
.up-count strong {
  color: #111;
}
.up-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 18px;
}
.up-thumb {
  position: relative;
  aspect-ratio: 1;
  border-radius: 10px;
  overflow: hidden;
  background: #f0f0f2;
}
.up-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.up-thumb-num {
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 10px;
}
.up-thumb-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}
.up-thumb-heic {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  text-align: center;
  padding: 4px;
}
.up-generate-btn {
  display: block;
  width: 100%;
  min-height: 58px;
  margin-top: 24px;
  border: none;
  border-radius: 14px;
  background: #e6288f;
  color: #fff;
  font-family: inherit;
  font-weight: 800;
  font-size: 1.05rem;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(230, 40, 143, 0.3);
  transition: transform 0.1s, opacity 0.15s;
}
.up-generate-btn:active:not(:disabled) {
  transform: scale(0.98);
}
.up-generate-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}
@media (min-width: 560px) {
  .up-card { padding: 36px 36px 32px; }
  .up-grid { grid-template-columns: repeat(4, 1fr); gap: 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/UploadProduct.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kEAAkE;AACpE;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,4CAA4C;AAC9C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,yCAAyC;AAC3C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW,uBAAuB,EAAE;EACpC,WAAW,qCAAqC,EAAE,SAAS,EAAE;AAC/D","sourcesContent":[".up-page {\n  min-height: 100vh;\n  background: #f4f4f6;\n  padding: 24px 16px 48px;\n  box-sizing: border-box;\n}\n.up-card {\n  max-width: 640px;\n  margin: 0 auto;\n  background: #fff;\n  border-radius: 20px;\n  padding: 28px 22px 24px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n}\n.up-title {\n  margin: 0 0 10px;\n  font-size: clamp(1.6rem, 6vw, 2.1rem);\n  line-height: 1.15;\n  color: #111;\n}\n.up-description {\n  margin: 0 0 22px;\n  color: #666;\n  font-size: 1rem;\n  line-height: 1.55;\n}\n.up-warning {\n  background: #fff3cd;\n  border: 1px solid #ffe69c;\n  border-radius: 10px;\n  padding: 12px 14px;\n  margin-bottom: 16px;\n  color: #856404;\n  font-size: 0.92rem;\n}\n.up-options {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n.up-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  min-height: 60px;\n  padding: 14px 18px;\n  background: #fff;\n  border: 2px solid #e6e6ea;\n  border-radius: 14px;\n  font-family: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;\n}\n.up-option.is-active {\n  border-color: #e6288f;\n  background: #fff5fa;\n  box-shadow: 0 4px 14px rgba(230, 40, 143, 0.15);\n}\n.up-option-label {\n  font-weight: 700;\n  font-size: 1rem;\n  color: #111;\n  text-align: left;\n}\n.up-option-price {\n  font-weight: 800;\n  font-size: 1.15rem;\n  color: #111;\n  white-space: nowrap;\n}\n.up-option.is-active .up-option-price {\n  color: #e6288f;\n}\n.up-select-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 54px;\n  background: #111;\n  color: #fff;\n  border-radius: 14px;\n  font-weight: 700;\n  font-size: 1.05rem;\n  cursor: pointer;\n  transition: transform 0.1s, background 0.15s;\n}\n.up-select-btn:active {\n  transform: scale(0.98);\n}\n.up-count {\n  margin: 12px 0 0;\n  text-align: center;\n  color: #666;\n  font-size: 0.95rem;\n}\n.up-count strong {\n  color: #111;\n}\n.up-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  margin-top: 18px;\n}\n.up-thumb {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #f0f0f2;\n}\n.up-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.up-thumb-num {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.65);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 10px;\n}\n.up-thumb-remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  z-index: 1;\n  width: 26px;\n  height: 26px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.65);\n  color: #fff;\n  font-size: 12px;\n  cursor: pointer;\n}\n.up-thumb-heic {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  text-align: center;\n  padding: 4px;\n}\n.up-generate-btn {\n  display: block;\n  width: 100%;\n  min-height: 58px;\n  margin-top: 24px;\n  border: none;\n  border-radius: 14px;\n  background: #e6288f;\n  color: #fff;\n  font-family: inherit;\n  font-weight: 800;\n  font-size: 1.05rem;\n  cursor: pointer;\n  box-shadow: 0 8px 20px rgba(230, 40, 143, 0.3);\n  transition: transform 0.1s, opacity 0.15s;\n}\n.up-generate-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n.up-generate-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n@media (min-width: 560px) {\n  .up-card { padding: 36px 36px 32px; }\n  .up-grid { grid-template-columns: repeat(4, 1fr); gap: 10px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
